import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SuccessRoutingModule } from './success-routing.module';
import { SuccessComponent } from './success.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [SuccessComponent],
  imports: [CommonModule, SuccessRoutingModule, MatIconModule],
})
export class SuccessModule {}
